import { PropsWithChildren } from 'react'
import { Box, Typography } from '@mui/material'
import AuthLogo from '../../components/auth/authLogo'
import AuthLayout from '../../components/auth/authLayout'
import custom from '../../styles/mui/szVariables.json'
import { analyticsCta, analyticsDomain } from '../../services/constants'
import { sendClickAnalytics } from '../common/util/util'

export default function AuthHeader({ 
        id, title, description, children 
    }: any & PropsWithChildren
) {
  
  function handleTelClick() {
    sendClickAnalytics('/signin', {
          domain: analyticsDomain.welcome,
          name: analyticsCta.contactUs,
          metadata: {},
      })   
  }

  return (
    <AuthLayout>
      <Box id={id} 
          display="flex" 
          p={custom.spacing.lg}
          flexDirection={"column"}
          sx={{ 
            backgroundColor: '#FFF',
            borderRadius: custom.corners7
          }}
          >
        <Box id={"solarZerologo"}
              display={{
                xs: "flex",
                sm: 'none',
                md: 'none',
                lg: 'none',
              }} 
              justifyContent={"flex-start"}
              mb={custom.spacing.md}>
          <AuthLogo />
        </Box>
        <Box>
          <Typography 
            id={id+"Title"}
            variant="szHeading.Bold.xLarge" 
            textAlign="left">
             {title}
          </Typography>
        </Box>    
        <Box display={"flex"} 
              justifyContent={"center"}
              my={custom.spacing.xxs}>
          <Typography
            id={id+"Description"}  
            textAlign="left" 
            variant="szBody.Regular.Large">
            {description}
          </Typography>
        </Box>

        {children}
        
        <Box width="100%" mt={custom.spacing.lg}
            display="flex" 
            flexDirection={"column"}
            alignItems={"center"}
            justifyContent={"center"}>
            <Typography id="supportTitle"
                variant="szHeading.Regular.xxSmall">
                Need Support?
            </Typography>
            <Typography id="supportDescription" 
              variant="szBody.Regular.xSmall">
              Give us a call. Our energy experts are here to help.
            </Typography>
            <Typography id="supportPhone"
              variant="szBody.Medium.Small"
              color="primary.main">
              <a href="tel:0800116655" onClick={handleTelClick}
                  style={{ textDecoration: 'none'}}>
                    0800 11 66 55
              </a>
            </Typography>
        </Box>

      </Box>
    </AuthLayout>
  )
}
